// extracted by mini-css-extract-plugin
module.exports = {"searchPopularityeChart":"searchPopularity_searchPopularityeChart__3QQR3","title":"searchPopularity_title__1Cbkn"};